import React from "react";
import retiraMascaraTelefone from "./retiraMascaraTelefone";

const renderSocialLinks = (revenda) => {
    const socialLinks = [
        { href: revenda.instagram_link, icon: "fa-instagram" },
        {
            href: `https://api.whatsapp.com/send?text=Olá, tudo bem? Estou com uma dúvida, poderia me ajudar? &phone=55${retiraMascaraTelefone(revenda.petelefone2, "link")}`,
            icon: "fa-whatsapp",
        },
        { href: revenda.mapa_link, icon: "fa-map-marker" },
    ];

    return (
        <ul className="social-links">
            {socialLinks.map(({ href, icon, customIcon }, index) => (
                <li key={index}>
                    <a href={href} target="_blank" rel="noopener noreferrer">
                        {customIcon || <i className={`fa ${icon}`} />}
                    </a>
                </li>
            ))}
        </ul>
    );
};

export default renderSocialLinks;